import { http } from '../helpers/axiosHelper';
class moduleAttributeAppearanceService {
   async post(body: any) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module-attribute-appearance', body, {
            params: { include: 'module_attribute,module_attribute.attributable,module_attribute.module_attribute_appearances' },
         })
         .then((response) => {
            return response.data;
         });
   }
   async delete(module_attribute_appearance_id: any) {
      return await http.delete(
         import.meta.env.VITE_APP_API_BASE_URL_DATA + `/module-attribute-appearance/${module_attribute_appearance_id}`
      );
   }

   async patch(module_attribute_appearance_id: Number, body: any) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/module-attribute-appearance/' + module_attribute_appearance_id, body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon module attribute appearance niet wijzigen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon module attribute appearance niet wijzigen`);
         });
   }
}
export default new moduleAttributeAppearanceService();
